import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './resultTab.module.scss';
const cx = classnames.bind(styles);

type TabType = 'PACC' | 'PST' | 'DCHAMPS';

interface ResultTabProps {
  tab: TabType;
}

const ResultTab = ({ tab }: ResultTabProps) => {
  const isOn = (tabType: TabType) => tabType === tab;

  return (
    <div className={cx('tabArea')}>
      <Link href={RouteUrl.PHS_PACC_RESULTS} legacyBehavior>
        <a className={cx('tab', { on: isOn('PACC') })} role="button">
          개발자 역검
        </a>
      </Link>
      <Link href={RouteUrl.PHS_PST_RESULTS} legacyBehavior>
        <a className={cx('tab', { on: isOn('PST') })} role="button">
          개발 구현 능력 검사
        </a>
      </Link>
      <Link href={RouteUrl.PHS_DCHAMPS_RESULTS} legacyBehavior>
        <a className={cx('tab', { on: isOn('DCHAMPS') })} role="button">
          디챔스
        </a>
      </Link>
    </div>
  );
};

export default ResultTab;
